export enum RoutesEnum {
  Default = '/',
  Dashboard = '/dashboard',
  DashboardComercial = '/comercial/dashboard',
  SignIn = '/login',
  SignUp = '/register',
  Veiculos = '/veiculos',
  Usuários = '/usuarios',
  UnidadesRecebiveis = '/cerc/solicitacao-consulta',
  Vendas = '/admin/painel-de-vendas'
}
